import { SDate } from '@summit/core';
import { SummitFormattedText } from '@summit/models';
import { Dayjs } from 'dayjs';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { Employee } from '../../employee/employee';
import { EmployeePayrollGroup } from '../../employee/employee-payroll-group';
import { EmployeeStatus } from '../../employee/status/employee-status.enum';
import { Company } from '../../organization/company/company';
import {
  GetApplicableEmployee,
  GetDefaultSortString,
  IWageRuleOrdered
} from '../../payroll/shared/i-wage-rule-ordered';
import { EWageRule } from '../../shared/payroll/e-wage-rule';
import { WageEmployeeFilterType } from '../../shared/payroll/wage-employee-filter-type.enum';

export class DivisionWageRule extends EWageRule implements IWageRuleOrdered {
  divisionId: string;

  //IWage Rule Ordered
  createdDate: Dayjs;
  employeeFilterType: WageEmployeeFilterType;
  employeeId: string;
  employee: Employee;
  companyId: string;
  company: Company;
  invertFilter: boolean;
  payrollGroupId: string;
  payrollGroup: EmployeePayrollGroup;
  employeeStatus: EmployeeStatus;
  startTime: Dayjs;
  endTime: Dayjs;

  ruleSetId: string; //future use but part of interface
  ruleSet: EboNameObject; //future use but part of interface

  constructor(jsonData: Partial<DivisionWageRule>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.startTime) this.startTime = SDate.newUtc(jsonData.startTime);
      if (jsonData.endTime) this.endTime = SDate.newUtc(jsonData.endTime);
      if (jsonData.createdDate) this.createdDate = SDate.newUtc(jsonData.createdDate);
      if (jsonData.employee) this.employee = new Employee(jsonData.employee);
      if (jsonData.company) this.company = new Company(jsonData.company);
      if (jsonData.payrollGroup) this.payrollGroup = new EmployeePayrollGroup(jsonData.payrollGroup);
    }
    this.employeeFilterType ??= WageEmployeeFilterType.All;
  }

  get defaultSort() {
    return GetDefaultSortString(this);
  }

  get applicableEmployee(): SummitFormattedText {
    return GetApplicableEmployee(this);
  }

  isActive(): boolean {
    const now = SDate.getNormalized();
    return this.startTime.isSameOrBefore(now) && (!this.endTime || this.endTime.isSameOrAfter(now));
  }
}
